//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class NotificationModel extends ModelBase {
      static readonly $typeName = 'NotificationModel';
      public submittingEntity: LookupModel;
      public type: LookupModel;
      public userKey: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/NotificationModel.ts